<template>
    <div class="guide-page">
        <div class="guide-wrapper">

            <div class="guide-header">
                <span class="guide-title">M&amp;M Security Gatehouse</span>
            </div>

            <div class="guide-body">
                <p class="guide-intro">{{ $t('guide.intro') }}</p>

                <template v-for="(section, index) in sections" :key="index">
                    <div class="guide-divider" v-if="index > 0"></div>
                    <div class="guide-section">
                        <div class="section-header">
                            <div class="section-number">{{ index + 1 }}</div>
                            <h2 class="section-title">{{ section.title }}</h2>
                        </div>
                        <p class="section-text">{{ section.text }}</p>
                    </div>
                </template>

                <div class="guide-cta">
                    <p class="cta-text">{{ $t('guide.ctaText') }}</p>
                    <a href="/" class="cta-button">{{ $t('guide.ctaButton') }}</a>
                </div>
            </div>

            <div class="guide-footer">
                <p>&copy; M&amp;M Security &mdash; Interní systém</p>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const sections = computed(() => [
    { title: t('guide.section1Title'), text: t('guide.section1Text') },
    { title: t('guide.section2Title'), text: t('guide.section2Text') },
    { title: t('guide.section3Title'), text: t('guide.section3Text') },
    { title: t('guide.section4Title'), text: t('guide.section4Text') },
])
</script>

<style scoped>
.guide-page {
    min-height: 100vh;
    background-color: #F0EFEA;
    padding: 40px 16px;
    font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.guide-wrapper {
    max-width: 700px;
    margin: 0 auto;
}

.guide-header {
    background-color: #F9900F;
    border-radius: 10px 10px 0 0;
    padding: 28px 40px;
    text-align: center;
}

.guide-title {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.5px;
}

.guide-body {
    background-color: #ffffff;
    border-left: 1px solid #e0dfd9;
    border-right: 1px solid #e0dfd9;
    padding: 40px;
}

.guide-intro {
    font-size: 15px;
    color: #6b6b6b;
    margin: 0 0 32px 0;
    line-height: 1.6;
}

.guide-divider {
    border-top: 1px solid #e0dfd9;
    margin-bottom: 28px;
}

.guide-section {
    margin-bottom: 28px;
}

.section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.section-number {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background-color: #F9900F;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 15px;
}

.section-title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
}

.section-text {
    margin: 0;
    font-size: 15px;
    color: #4a4a4a;
    line-height: 1.7;
    padding-left: 48px;
}

.guide-cta {
    text-align: center;
    border-top: 1px solid #e0dfd9;
    padding-top: 32px;
    margin-top: 4px;
}

.cta-text {
    margin: 0 0 20px 0;
    font-size: 15px;
    color: #4a4a4a;
}

.cta-button {
    display: inline-block;
    padding: 14px 40px;
    background-color: #F9900F;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    border-radius: 6px;
    letter-spacing: 0.3px;
    transition: background-color 0.2s;
}

.cta-button:hover {
    background-color: #e0820a;
    color: #ffffff;
}

.guide-footer {
    background-color: #4A4A4A;
    border-radius: 0 0 10px 10px;
    padding: 20px 40px;
    text-align: center;
}

.guide-footer p {
    margin: 0;
    font-size: 13px;
    color: #cccccc;
}
</style>
